var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUniverselection = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.-Menu-General-",
    transform: "translate(-34.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.-Visualization",
    transform: "translate(33.000000, 321.989154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Selection",
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.998265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Content-/-add_box",
    transform: "translate(0.000000, 1.199479)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 14 0 14 14 0 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0833333,1.75 L2.91666667,1.75 C2.26916667,1.75 1.75,2.275 1.75,2.91666667 L1.75,11.0833333 C1.75,11.725 2.26916667,12.25 2.91666667,12.25 L11.0833333,12.25 C11.725,12.25 12.25,11.725 12.25,11.0833333 L12.25,2.91666667 C12.25,2.275 11.725,1.75 11.0833333,1.75 Z M11.0833333,11.0833333 L2.91666667,11.0833333 L2.91666667,2.91666667 L11.0833333,2.91666667 L11.0833333,11.0833333 Z M6.41666667,9.91666667 L7.58333333,9.91666667 L7.58333333,7.58333333 L9.91666667,7.58333333 L9.91666667,6.41666667 L7.58333333,6.41666667 L7.58333333,4.08333333 L6.41666667,4.08333333 L6.41666667,6.41666667 L4.08333333,6.41666667 L4.08333333,7.58333333 L6.41666667,7.58333333 L6.41666667,9.91666667 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUniverselection, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/universelection.eedc6317.svg";
export { ForwardRef as ReactComponent };